import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  resetPassword(email: string) {
    const url = `${this.apiUrl}/api/user/resetPassword?api-version=1.0`;

    const requestBody = {
      email: email,
    };

    // Define HTTP headers (if needed)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', // Set the content type if required
    });

    // Send a POST request with the request body
    return this.http.put(url, requestBody, { headers });
  }

  updatePassword(token: string, password: string) {
    const url = `${this.apiUrl}/api/user/updatePassword?api-version=1.0`;

    const requestBody = {
      token: token,
      password: password,
    };

    // Define HTTP headers (if needed)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', // Set the content type if required
    });

    // Send a POST request with the request body
    return this.http.put(url, requestBody, { headers });
  }
}
